import PropTypes from 'prop-types'
import styled from 'styled-components'
import breakpoints from 'theme/breakpoints'
import Box from '@mui/material/Box'

const SIZES = {
  narrowest: '625px',
  narrower: '965px',
  narrow: '1130px',
  default: `${breakpoints.lg}px`,
  full: '100%',
  fullBleed: '100%',
}

const Container = styled(Box).withConfig({
  shouldForwardProp: prop => ![
    'fluidBelow',
    'container',
    'hideEmpty',
  ].includes(prop),
})`
  width: 100%;
  max-width: ${props => SIZES[props.container] || SIZES.default};
  margin-left: auto;
  margin-right: auto;
  min-width: 1px;
  ${props => props.theme.internalMixins.px(props.container === 'fullBleed' ? 0 : 1.5)}
  ${props => props.theme.internalMixins.mqObj(props.theme.internalMixins.px(props.container === 'fullBleed' ? 0 : 4), 'md')}
  ${props => props.fluidBelow ? props.theme.internalMixins.mqObj(props.theme.internalMixins.px(0), 'xx', props.fluidBelow) : ''}
  ${props => props.hideEmpty ? '&:empty { display: none; } ' : ''}
`

Container.propTypes = {
  container: PropTypes.oneOf([...Object.keys(SIZES), true, false, undefined]),
  fluidBelow: PropTypes.oneOf(Object.keys(breakpoints)),
  hideEmpty: PropTypes.bool,
}

Container.defaultProps = {
  container: 'default',
}

export default Container
